import React, { Component } from "react";
import { Icon, message, Select, Table, Input, InputNumber, Form, Button } from 'antd';
import moment from 'moment';
import { db } from '../firebase/firebase';

const success = (x) => {
  message.success(x);
}

const Option2 = Select.Option;
const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);
const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  getInput = () => {
    if (this.props.inputType === 'number') {
      return <InputNumber />;
    }
    return <Input />;
  };

  render() {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      ...restProps
    } = this.props;
    return (
      <EditableContext.Consumer>
        {(form) => {
          const { getFieldDecorator } = form;
          return (
            <td {...restProps}>
              {editing ? (
                <FormItem style={{ margin: 0 }}>
                  {getFieldDecorator(dataIndex, {
                    rules: [{
                      required: false,
                      message: `Please Input ${title}!`,
                    }],
                    initialValue: record[dataIndex],
                  })(this.getInput())}
                </FormItem>
              ) : restProps.children}
            </td>
          );
        }}
      </EditableContext.Consumer>
    );
  }
}

export class EditableTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      major: [],
      editingKey: '',
      tempStatus: '',
      ta: null,
      xa: null,
      ya: null,
      sa: null,
      ca: null
    };
    this.columns = [
      // {
      //   title: 'PK',
      //   dataIndex: 'key',
      //   width: '5%',
      //   editable: false,
      // },
      {
        title: 'Unit Type',
        dataIndex: 'unittype',
        ...this.getColumnSearchProps('unittype'),
        editable: false,
        sorter: (a, b) => { return a.unittype.localeCompare(b.unittype) },
      },
      {
        title: 'Lot',
        dataIndex: 'lot',
        ...this.getColumnSearchProps('lot'),
        editable: false,
        sorter: (a, b) => { return a.lot.localeCompare(b.lot) },
      },
      {
        title: 'Unit No.',
        dataIndex: 'unitno',
        ...this.getColumnSearchProps('unitno'),
        editable: false,
        sorter: (a, b) => { return a.unitno.localeCompare(b.unitno) },
      },
      {
        title: 'Size',
        dataIndex: 'size',
        ...this.getColumnSearchProps('size'),
        editable: false,
        sorter: (a, b) => parseInt(a.size, 10) - parseInt(b.size, 10),
        onHeaderCell: (column) => {
          return {
            onClick: () => {
              console.log('onClick');
            }
          };
        }
      },
      {
        title: 'Price',
        dataIndex: 'price',
        ...this.getColumnSearchProps('price'),
        editable: true,
        sorter: (a, b) => parseInt(a.price, 10) - parseInt(b.price, 10),
      },
      {
        title: 'Customer Name',
        dataIndex: 'customer',
        ...this.getColumnSearchProps('customer'),
        editable: true,
        sorter: (a, b) => a.customer.length - b.customer.length,
      },
      {
        title: 'Status',
        dataIndex: 'isSold',
        width: '9%',
        filters: [{
          text: 'Sold',
          value: 'Sold',
        }, {
          text: 'Open',
          value: 'Open',
        }],
        filterMultiple: false,
        onFilter: (value, record) => record.isSold.indexOf(value) === 0,
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <div>
                  <Select style={{ width: 120 }} defaultValue={this.state.data[record.key].isSold} onChange={(value) => this.selector(record.key, value)}>
                    <Option2 value="Open">Open</Option2>
                    <Option2 value="Sold">Sold</Option2>
                  </Select>
                </div>
              ) : (
                  <div>
                    {this.state.data[record.key].isSold}
                  </div>
                )}
            </div>
          );
        },
      },
      {
        title: '',
        dataIndex: 'operation',
        width: '15%',
        render: (text, record) => {
          const editable = this.isEditing(record);

          return (
            <div>
              {editable ? (
                <span>
                  <EditableContext.Consumer>
                    {form => (
                      <Button
                        onClick={() => this.save(form, record.key)}
                        style={{ marginRight: 8 }}
                      >
                        Save
                      </Button>
                    )}
                  </EditableContext.Consumer>
                  <Button
                    type="primary"
                    style={{ marginRight: 8 }}
                    onClick={() => this.cancel(record.key)}
                  >
                    Cancel
                  </Button>
                </span>
              ) : (
                  <div>
                    <Button
                      type="primary"
                      onClick={() => this.edit(record.key)}
                      className="App-t"
                    >
                      Edit
                </Button>
                    {/* THIS IS THE DELETE BUTTON (TURNED OFF BY REQUEST) */}
                    {/* <Divider type="vertical" />
                    <Popconfirm
                      title="Confirm Delete?"
                      onConfirm={evt => this.deleteProject(record.key)}
                    >
                      <Button>Delete</Button>
                    </Popconfirm> */}

                  </div>
                )}
            </div>
          );
        },
      },
    ];

    this.addProject = this.addProject.bind(this);
    this.deleteProject = this.deleteProject.bind(this);
    this.exportFile = this.exportFile.bind(this)
    this.pullFromDB();
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys, selectedKeys, confirm, clearFilters,
    }) => (
        <div style={{ padding: 8 }}>
          <Input
            ref={node => { this.searchInput = node; }}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
            style={{ width: 188, marginBottom: 8, display: 'block' }}
          />
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm)}
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Search
        </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
        </Button>
        </div>
      ),
    filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      text
    ),
  })

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  pullFromDB() {
    var baba;
    if (this.props.match.params.id) {
      baba = this.props.match.params.id
    }
    // We listen for live changes to our data collection in Firebase
    db.collection("units").where("projects", "==", baba).onSnapshot(snapshot => {
      //data is locally available array, pulled from firestore.
      let data = [];
      snapshot.forEach(doc => {
        const todo = doc.data();
        todo.id = doc.id;
        data.push(todo);
      });

      // Sort our data based on time added
      data.sort(function (a, b) {
        return (
          new Date(b.date).getTime() - new Date(a.date).getTime()
        );
      });

      //assign primary key
      for (var i = 0; i < data.length; i++) {
        data[i].key = i;
      }



      // Anytime the state of our database changes, we update state
      this.setState({ data });

    })
  }



  selector(key, value) {
    // this.state.data[key].isSold = value;
    this.setState({ tempStatus: value });
  }

  async deleteProject(id) {
    // alert("record.key: " + id + "todo id: " + this.state.data[id].id)
    await db
      .collection("units")
      .doc(this.state.data[id].id)
      .delete();
  }



  async addProject() {
    var na = moment()
    var bb = await db.collection("units").add({
      date: na.toISOString(),
      key: 1,
      unittype: "ba",
      projects: this.props.match.params.id,
      lot: "test",
      unitno: "test",
      price: "123",
      size: "321",
      xx: 1,
      yy: 1,
      isSold: "Open",
    });

    // this.pullFromDB();
  }


  isEditing = (record) => {
    return record.key === this.state.editingKey;
  };

  edit(key) {
    var tempB = this.state.data[key].isSold
    this.setState({ editingKey: key, tempStatus: tempB });
  }

  save(form, key) {
    if (navigator.onLine) {
      form.validateFields((error, row) => {
        if (error) {
          return;
        }
        const newData = [...this.state.data];
        const index = newData.findIndex(item => key === item.key);
        if (index > -1) {
          const item = newData[index];
          newData.splice(index, 1, {
            ...item,
            ...row,
          });

          if (!/^-?\d*[.]?\d{0,2}$/.test(newData[index].price)) {
            message.error('Numbers only. Decimal point is allowed.')
          } else {
            message.loading('Updating..', 0)
            newData[index].isSold = this.state.tempStatus
            // this.state.sa = newData[index].isSold
            // this.state.ca = newData[index].customer

            try {
            db
              .collection("units")
              .doc(this.state.data[index].id).update({
                price: newData[index].price,
                customer: newData[index].customer,
                isSold: newData[index].isSold
              })
              .then((value) => {
                message.destroy()
                success('Successfully updated [Price: ' + newData[index].price + '] [Customer: ' + newData[index].customer + '] [Status: ' + newData[index].isSold + ']'
                );
                this.setState({ data: newData, editingKey: '' });
              })
              .catch(function (error) {
                // The document probably doesn't exist.
                message.destroy()
                message.error(error.message);
              });
            } catch (error) {
              message.destroy()
              message.error(error.message);
            }
            // this.setState({ data: newData, editingKey: '' });
          }
        } else {
          newData.push(row);
          this.setState({ data: newData, editingKey: '' });
        }
      });
    } else {
      message.error('Can\'t save, no internet connection.')
    }

  }

  cancel = () => {
    this.setState({ editingKey: '' });
  };


  exportFile() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      message.error('This feature is only on PC.')
    } else {
      this.state.major = [];
      var i;
      for (i = 0; i < this.state.data.length; i++) {
        var lol = [
          this.state.data[i].id,
          this.state.data[i].projects,
          this.state.data[i].unittype,
          this.state.data[i].lot,
          this.state.data[i].unitno,
          this.state.data[i].size,
          this.state.data[i].price,
          this.state.data[i].customer,
          this.state.data[i].yy,
          this.state.data[i].xx,
          this.state.data[i].date,
          this.state.data[i].isSold
        ];
        this.state.major.push(lol)
      }

      // console.log(this.state.major)
      // alert("the string: " + this.state.major.toString())
      success('Downloading ' + this.state.major.length + " records...")
      if (this.state.major.length > 1)
        this.downloadcsv();
    }
  }

  downloadcsv = (e) => {
    // console.log("heyy2 " + this.state.major);
    var csv = `doc_id,projects,unittype,lot,unitno,size,price,customer,yy,xx,date,isSold,\n`
    this.state.major.forEach(function (row) {
      csv += row.join(',');
      csv += "\n";
    });

    var hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = this.props.match.params.name + '.csv';
    hiddenElement.click();
  }


  render() {
    const components = {
      body: {
        row: EditableFormRow,
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          record,
          inputType: col.dataIndex === 'price' ? 'text' : 'text',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
        }),
      };
    });

    return (
      <div>
        <h1>{this.props.match.params.name}</h1>
        <div className="csvbtn" >
          <Button onClick={this.exportFile}>Export to CSV</Button>
        </div>
        {/* <Button
          className="App-add-todo-button"
          size="large"
          type="primary"
          onClick={this.addProject}
        >
          （add a project)
          </Button> */}
        <Table
          components={components}
          bordered
          dataSource={this.state.data}
          columns={columns}
          pagination={{ pageSize: 50 }}
          rowClassName="editable-row"
        />
      </div>
    );
  }
}

export default EditableTable;




// WEBPACK FOOTER //
// ./src/views/projects.js